import React from 'react';
import { twMerge } from 'tailwind-merge';
import classNames from 'classnames';

function ButtonTertiary({ children, onClick, className, disabled = false }) {
  return (
    <button
      className={twMerge(
        classNames(
          'flex h-[55px] items-center rounded bg-tertiary-cta disabled:bg-gray-300 disabled:text-aw-midnight',
          'py-2 px-3 font-aw-serif font-bold shadow-md text-tertiary-cta-text lg:py-4 lg:px-6',
          'hover:bg-primary-cta-text hover:text-primary-cta hover:border-primary-cta-text '
        ),
        className
      )}
      onClick={onClick}
      disabled={!!disabled}
    >
      {children}
    </button>
  );
}

export default ButtonTertiary;
